module.exports = __webpack_public_path__ + "static/media/10.658c8c8d.jpg";